(() => {
  const text = {
    heading: 'Available to order · Overseas stock',
    dispatch: 'Estimated dispatch: 8–15 business days after checkout, plus delivery time.',
    terms: 'I understand the estimated dispatch timeframe.',
    caveat: 'This item is in stock overseas and imported to order. It is not available for immediate local dispatch. Please allow additional delivery time after dispatch. It is unsuitable for urgent orders or last-minute gifts. Delivery by a specific date is not guaranteed.'
  };
  let queued = false;
  const observer = new MutationObserver(() => {
    if (!queued) {
      queued = true;
      requestAnimationFrame(update);
    }
  });
  function update() {
    queued = false;
    observer.disconnect();
    document.querySelectorAll('product-form').forEach(form => {
      const button = form.querySelector('.restock-rocket-preorder-button');
      const description = form.querySelector('.restock-rocket-preorder-description');
      const existing = form.querySelector('.overseas-stock-notice');
      const offerClass = button && Array.from(button.classList).find(name => name.startsWith('restock-rocket-preorder-offer-style-'));
      const overseas = button && description && (
        button.textContent.trim() === 'ORDER OVERSEAS STOCK' ||
        description.textContent.includes('IN STOCK OVERSEAS') ||
        (existing && description.dataset.overseasRedesign === 'true' && description.dataset.overseasOffer === offerClass)
      );
      if (!overseas) {
        existing?.remove();
        form.querySelector('.overseas-stock-button')?.classList.remove('overseas-stock-button');
        return;
      }
      button.classList.add('overseas-stock-button');
      const span = button.querySelector('span');
      if (span && span.textContent !== 'Add to cart') span.textContent = 'Add to cart';
      const acknowledgement = form.querySelector('.restock-rocket-acknowledgement-checkbox');
      const label = acknowledgement?.querySelector('label');
      if (label && label.textContent !== text.terms) label.textContent = text.terms;
      if (!existing) {
        const notice = document.createElement('div');
        notice.className = 'overseas-stock-notice';
        const heading = document.createElement('strong');
        heading.textContent = text.heading;
        const dispatch = document.createElement('p');
        dispatch.textContent = text.dispatch;
        notice.append(heading, dispatch);
        (acknowledgement || button).before(notice);
      }
      if (description.dataset.overseasRedesign !== 'true') {
        const details = document.createElement('details');
        details.className = 'overseas-stock-details';
        const summary = document.createElement('summary');
        summary.textContent = 'Shipping & delivery information';
        const caveat = document.createElement('p');
        caveat.textContent = text.caveat;
        details.append(summary, caveat);
        description.replaceChildren(details);
        description.dataset.overseasRedesign = 'true';
        description.dataset.overseasOffer = offerClass;
        description.classList.add('overseas-stock-description');
      }
    });
    document.querySelectorAll('.stoq-preorder-modal').forEach(modal => {
      const heading = modal.querySelector('#preorder-header-text');
      if (!heading || heading.textContent.trim() !== 'ORDER OVERSEAS STOCK') return;
      heading.textContent = 'Add to cart';
      const disclaimer = modal.querySelector('#preorder-disclaimer-text');
      if (disclaimer) disclaimer.textContent = text.heading + ' — ' + text.dispatch;
      modal.querySelectorAll('.restock-rocket-acknowledge-checkbox-label').forEach(label => { label.textContent = text.terms; });
    });
    observer.observe(document.body, {subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['class']});
  }
  update();
})();
